import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AnnouncementState } from '../state/announcement.state'

const getAnnouncementState = createFeatureSelector<AnnouncementState>('announcement')

export const getAllAnnouncementSummary = () =>
  createSelector(getAnnouncementState, state => {
    return state?.summary
  })

  export const getAnnouncementDetails = () =>
    createSelector(getAnnouncementState, state => {
      return state?.details
    })

